import React, {useEffect, useState,useRef} from 'react'
import {useDispatch} from 'react-redux'
import {setMessage} from '../../../../store/alertMessage/actions'
import {changePasswordApi} from '../../../../app/modules/auth/core/_requests'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageTitle} from 'src/_metronic/layout/core'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom';
import { KTSVG } from 'src/_metronic/helpers'


const ChangePsw = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState<string | null>(null)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [mobileNumber, setMobileNumber] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const dispatch = useDispatch()

  const loginData: any = localStorage.getItem('branch')
  const currentUser = JSON.parse(loginData)
  document.title = `PANEL | Change Password`
//   useEffect(() => {
//     // Set the title when the component mounts
//     const originalTitle = document.title; // Store the original title
//     document.title = `${currentUser.branch_name} :: Change Password`

//     // Cleanup: Revert to the original title (or a default) when unmounting
//     return () => {
//         document.title = originalTitle; // Or set a default like "My App"
//     }
// }, [currentUser.branch_name])
  useEffect(() => {
    const userData = localStorage.getItem('branch');
    if (userData) {
        const currentUser = JSON.parse(userData);
        if (currentUser && currentUser.mobile_number) {
            setMobileNumber(currentUser.mobile_number);
        }
    }
}, []);


  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef?.current?.focus();
    }
  }, []);
  const changePasswordInitialValues = {
    old_password: '',
    password: '',
    confirmPassword: '',
  }

  const editChangePasswordSchema = Yup.object().shape({
    old_password: Yup.string()
      .required('Old password is required')
      .min(7, 'Password must be at least 7 characters'),
    password: Yup.string()
      .required('New password is required')
      .min(7, 'Password must be at least 7 characters')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,}$/,
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character. ex - Abcd@123'
      )
      .notOneOf([Yup.ref('old_password')], 'New password cannot be the same as the old password'),
    confirmPassword: Yup.string()
      .required('Confirm password is required')
      .oneOf([Yup.ref('password'), null], "Password don't match. Please try again."),
  })
  
  const formik = useFormik({
    initialValues: changePasswordInitialValues,
    validationSchema: editChangePasswordSchema,
    onSubmit: async (values, {setSubmitting,resetForm}) => {
      let sendData = JSON.parse(JSON.stringify(values))
      setSubmitting(true)
      try {
        setLoading(true)
        await changePasswordApi({
          // email,
          mobileno: mobileNumber,
          old_password: formik?.values?.old_password,
          password: formik?.values?.password,
        })

          .then((data: any) => {
        console.log("response",data);

            console.log("response",data.status);
            
            if (data?.status === 200) {
              dispatch(setMessage('success', data?.data?.message ?? data?.responseMessage ?? "Password changed"));

              resetForm();
            } else {
              // Handle the specific 400 error case with incorrect password
              if (data?.status === 400 && data?.Error?.message === "Please enter correct old password") {
                dispatch(setMessage('error', "Please enter correct old password"));
              } else {
                dispatch(setMessage('error', data?.data?.message ?? data?.responseMessage));
              }
            }
            setLoading(false)
            setSubmitting(false)
          })
          .catch((error: any) => {
            console.log("this error",error);
            
            if (error?.response?.status === 400) {
              const errorData = error.response.data;
              if (errorData?.Error?.message === "Please enter correct old password") {
                dispatch(setMessage("error", "Please enter correct old password"));
              } else {
                const errorMsg = 
                  errorData?.responseData?.msg ||
                  errorData?.responseMessage ||
                  error?.message;
                dispatch(setMessage("error", errorMsg));
              }
            } else {
              dispatch(setMessage("error", error?.message || "An unexpected error occurred"));
            }
            setLoading(false)
            setSubmitting(false)
          })
      } catch (ex) {
        console.error(ex)
      }
    },
  })

  return (
    <>
    {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button onClick={() => navigate(-1)} className="btn btn-secondary">
                ← Back
              </button>
              </div> */}
              <div
                      className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
                      style={{ zIndex: 99, top: "33px", marginLeft: "-34px" ,width: "34px",
                        height: "32px"}}
                      role="button"
                      aria-label="Go back to previous page"
                      tabIndex={0}
                      data-tooltip="Back"
                      onClick={() => navigate(-1)}
                    >
                      <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
                    </div>
      <h2 className='text-center mb-10'>Change Password</h2>
      
      <div className='card col-md-6 mx-auto p-15'>
        <form onSubmit={formik.handleSubmit} noValidate>
        <div className='mb-6'>
  <label className='required fs-4 form-label'>Old Password</label>
  <div style={{position: 'relative'}}>
    <input
      type={showOldPassword ? 'text' : 'password'}
      className='form-control'
      placeholder='Enter Old Password'
      ref={inputRef}
      value={formik?.values?.old_password}
      onChange={(e) => formik.setFieldValue('old_password', e.target.value.trimStart())}
    />
    <span
      onClick={() => setShowOldPassword(!showOldPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
      }}
    >
      {showOldPassword ? (
        // Eye with slash icon (Hide)
        <i className='fa fa-eye' style={{ color: "#323248" }}></i>
      ) : (
        // Normal eye icon (Show)
        <i className='fa fa-eye-slash'></i>
       
      )}
    </span>
  </div>
  {formik.touched.old_password && formik.errors.old_password && (
    <div className='fv-plugins-message-container text-danger'>
      <span role='alert'>{formik.errors.old_password}</span>
    </div>
  )}
</div>

<div className='mb-6'>
  <label className='required fs-4 form-label'>New Password</label>
  <div style={{position: 'relative'}}>
    <input
      type={showNewPassword ? 'text' : 'password'}
      className='form-control'
      placeholder='Enter New Password'
      value={formik?.values?.password}
      onChange={(e) => formik.setFieldValue('password', e.target.value.trimStart())}
    />
    <span
      onClick={() => setShowNewPassword(!showNewPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
      }}
    >
      {showNewPassword ? (
         <i className='fa fa-eye' style={{ color: "#323248" }}></i>
        ) : (
          // Normal eye icon (Show)
          <i className='fa fa-eye-slash'></i>
      )}
    </span>
  </div>
  {formik.touched.password && formik.errors.password && (
    <div className='fv-plugins-message-container text-danger'>
      <span role='alert'>{formik.errors.password}</span>
    </div>
  )}
</div>

<div className='mb-6'>
  <label className='required fs-4 form-label'>Confirm Password</label>
  <div style={{position: 'relative'}}>
    <input
      type={showConfirmPassword ? 'text' : 'password'}
      className='form-control'
      placeholder='Enter Confirm Password'
      value={formik?.values?.confirmPassword}
      onChange={(e) => formik.setFieldValue('confirmPassword', e.target.value.trimStart())}
    />
    <span
      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
      }}
    >
      {showConfirmPassword ? (
        <i className='fa fa-eye' style={{ color: "#323248" }} ></i>
      ) : (
        // Normal eye icon (Show)
        <i className='fa fa-eye-slash'></i>
      )}
    </span>
  </div>
  {formik.touched.confirmPassword && formik.errors.confirmPassword && (
    <div className='fv-plugins-message-container text-danger'>
      <span role='alert'>{formik.errors.confirmPassword}</span>
    </div>
  )}
</div>

          <div className='mt-6 text-center'>
            <button type='submit' className='btn btn-primary w-100 fs-2' disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default ChangePsw
